import { FC, memo } from "react";

import { Building, Time, TrashCan } from "@carbon/icons-react";

import { Badge } from "@/components/ui/badge";
import { formatDistance } from "@/utils/date";

import RestoreGroupModal from "../../screens/RootGroupDeletedScreen/RestoreGroupModal";
import { RestoreGroup } from "../../types/group.type";

interface GroupCardProps {
  group: RestoreGroup;
}

const GroupCard: FC<GroupCardProps> = ({ group }) => {
  return (
    <div className="group relative bg-white rounded-2xl border border-secondary-200 hover:border-red-300 hover:shadow-xl transition-all duration-300 ease-out overflow-hidden opacity-90 hover:opacity-100">
      {/* Cover Image with Overlay */}
      <div className="relative h-48 overflow-hidden bg-gradient-to-br from-red-50 to-red-100">
        {group.photoUrl ? (
          <img
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 grayscale hover:grayscale-0"
            src={group.photoUrl}
            alt={group.name}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-red-100 via-red-50 to-secondary-50">
            <div className="text-center">
              <Building
                size={48}
                className="text-red-400 mx-auto mb-2"
              />
              <span className="text-sm font-medium text-red-600">
                Tổ chức đã xóa
              </span>
            </div>
          </div>
        )}

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>

        {/* Group Type Badge */}
        <div className="absolute top-4 left-4">
          <Badge className="px-2 py-1 text-xs font-medium rounded-full border-0 backdrop-blur-sm bg-white/90 text-red-700">
            <Building
              size={12}
              className="mr-1"
            />
            Tổ chức
          </Badge>
        </div>

        {/* Deleted Status Badge */}
        <div className="absolute top-4 right-4">
          <Badge className="px-2 py-1 text-xs font-medium rounded-full border-0 backdrop-blur-sm bg-red-100/90 text-red-700">
            <TrashCan
              size={12}
              className="mr-1"
            />
            Đã xóa
          </Badge>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Header */}
        <div className="mb-4">
          <div className="flex items-center text-xs font-medium text-red-500 uppercase tracking-wider mb-1">
            <span>Tổ chức đã xóa</span>
          </div>

          {/* Group Title */}
          <h3 className="mb-3">
            <span className="text-xl font-bold text-secondary-900 line-clamp-2 leading-tight">
              {group.name}
            </span>
          </h3>
        </div>

        {/* Deleted Info */}
        <div className="flex items-center space-x-2">
          <Time size={16} />
          <span className="text-sm font-medium  ">
            Đã xóa {formatDistance(group.deletedAt)}
          </span>
        </div>

        {/* Actions */}
        <div className="space-y-3 mt-4">
          <RestoreGroupModal group={group} />
        </div>
      </div>
    </div>
  );
};

export default memo(GroupCard);
